import React from "react";

interface NotificationProps {
  notification: {
    message: string;
    variant: string;
  };
}
const Notification = ({ notification }: NotificationProps) => {
  if (notification.message === "") {
    return <></>;
  }

  const variantClasses = {
    success: "bg-green-100 border-green-400 text-green-700",
    danger: "bg-red-100 border-red-400 text-red-700",
    warning: "bg-yellow-100 border-yellow-400 text-yellow-700",
    info: "bg-blue-100 border-blue-400 text-blue-700",
  };

  const className =
    variantClasses[notification.variant as keyof typeof variantClasses] || variantClasses.info;

  return (
    <div className={`border-l-4 p-4 mb-4 ${className}`} role="alert">
      {notification.message}
    </div>
  );
};

export default Notification;
